import {
  toThreeDecimals,
  toTwoDecimals,
} from "../components/NewDetail/calculations/utils";

const getMaterialSummaryData = (order) => {
  console.log("GET MATERIAL SUMMARY DATA OF ORDER", order.items);
  // TODO: Need to figure out how to differentiate between OLD and NEW version
  // Old Calculation Version
  // - no extra flats
  // - the flats needed are stored in each piece's calculations object

  // GET FLATS, STANDALONE FLATS, AND GALV FLATS NEEDED
  // FlatSheet
  // - exactly the same as before
  // - (OLD) standaloneFlats += flatSheet.quantity;
  // - (NEW) standaloneFlats += flatSheet.quantity;
  // Accessory (Yup we had an accessory named "flat sheet")
  // - exactly the same as before
  // - (OLD) standaloneFlats += accessoryItem.quantity
  // - (NEW) standaloneFlats += accessoryItem.quantity
  // TrimAndFlashing
  // - This is different from new version because new version calculates flats needed for the whole TrimAndFlashing and not each piece
  // - (OLD) flatsNeeded += parseInt(trimPiece.calculations.flatSheetsNeeded)
  // - (NEW) flatsNeeded += Number(orderItem.variables.flatsUsed) + Number(orderItem.variables.extra_flats)
  // - HOW TO CHECK OLD VS NEW: check if orderItem.variables.flatUsed or orderItem.variables.extra_flats exists, then new, if not, then old
  // BenchWork
  // - exactly the same as before
  // - (OLD) flatsNeeded += parseInt(benchWorkPiece.flatSheets);
  // - (NEW) flatsNeeded += parseInt(benchWorkPiece.flatSheets);
  // CopingCap
  // - This is different from new version because new version calculates flats needed for the whole TrimAndFlashing and not each piece
  // - (OLD) flatsNeeded += parseInt(capPiece.calculations.flatSheetsNeeded)
  // - (NEW) flatsNeeded += Number(orderItem.variables.flatsUsed) + Number(orderItem.variables.extra_flats)
  // - HOW TO CHECK OLD VS NEW: check if orderItem.variables.flatUsed or orderItem.variables.extra_flats exists, then new, if not, then old
  // CopingCapCleat
  // - This is different from new version because new version calculates flats needed for the whole TrimAndFlashing and not each piece
  // - (OLD) galvFlatsNeeded += parseInt(cleatPiece.calculations.flatSheetsNeeded)
  // - (NEW) galvFlatsNeeded += Number(orderItem.variables.flatsUsed) + Number(orderItem.variables.extra_flats)
  // - HOW TO CHECK OLD VS NEW: check if orderItem.variables.flatUsed or orderItem.variables.extra_flats exists, then new, if not, then old
  // SplicePlate
  // - This is different from new version because new version calculates flats needed for the whole TrimAndFlashing and not each piece
  // - (OLD) flatsNeeded += parseInt(plate.calculations.flatSheetsNeeded);
  // - (NEW) flatsNeeded += Number(orderItem.variables.flatsUsed) // Splice Plates DONT have extra flats in both new and old
  // - HOW TO CHECK OLD VS NEW: check if orderItem.variables.flatUsed exists, then new, if not, then old

  // GET COIL NEEDED (NO CHANGE)
  // - Standalone Coil Lineal Footage - not including what's needed for panels
  // let totalLinealFootOfStandaloneCoil = Number(coilOrderItem && coilOrderItem.linealFeet ? coilOrderItem.linealFeet : 0);
  // - Total Lineal Footage of Coil Needed to Complete Order
  // Number(
  //   panelOrderItem &&
  //     panelOrderItem.calculations &&
  //     panelOrderItem.calculations.linealFeetOfCoilWithWaste
  //     ? panelOrderItem.calculations.linealFeetOfCoilWithWaste
  //     : 0
  // );
  // - Coil Width Needed to Create Panels
  // Number(
  //   panelOrderItem &&
  //     panelOrderItem.calculations &&
  //     panelOrderItem.calculations.masterCoilSizeNeeded
  //     ? panelOrderItem.calculations.masterCoilSizeNeeded
  //     : 0
  // );
  // - Total Coil Square Footage
  // Number(
  //   panelOrderItem &&
  //     panelOrderItem.calculations &&
  //     panelOrderItem.calculations.finishedPanelSquareFeet
  //     ? panelOrderItem.calculations.finishedPanelSquareFeet
  //     : 0
  // );
  // - Total Coil Square Footage inc Drop
  // Number(
  //   panelOrderItem &&
  //     panelOrderItem.calculations &&
  //     panelOrderItem.calculations.squareFeetOfCoilNeededWithWaste
  //     ? panelOrderItem.calculations.squareFeetOfCoilNeededWithWaste
  //     : 0
  // );
  // - Total Panel Area Coverage
  // toThreeDecimals(
  //   (panelOrderItem &&
  //   panelOrderItem.calculations &&
  //   panelOrderItem.calculations.linealFeetOfCoilNoWaste &&
  //   panelOrderItem.panelWidth
  //     ? parseFloat(panelOrderItem.calculations.linealFeetOfCoilNoWaste) *
  //       parseFloat(panelOrderItem.panelWidth)
  //     : 0) / 12
  // );
  let flatsNeeded = 0;
  let standaloneFlats = 0;
  let galvFlatsNeeded = 0;

  let totalLinealFootOfStandaloneCoil = 0;
  let totalLinealFootOfCoilNeededForPanels = 0;
  let coilWidthNeededForPanels = 0;
  let totalPanelCoilSquareFeet = 0;
  let totalPanelCoilSquareFeetIncDrop = 0;
  let totalPanelAreaCoverage = 0;

  for (const orderItem of order.items) {
    switch (orderItem.objectType) {
      case "Coil":
        let coil = orderItem;
        totalLinealFootOfStandaloneCoil += Number(
          coil && coil.linealFeet ? Number(coil.linealFeet ?? 0) : 0
        );
        break;
      case "FlatSheet":
        // FlatSheet
        // - exactly the same as before
        // - (OLD) standaloneFlats += flatSheet.quantity;
        // - (NEW) standaloneFlats += flatSheet.quantity;
        // Accessory (Yup we had an accessory named "flat
        let flatSheet = orderItem;
        standaloneFlats += Number(flatSheet.quantity ?? 0);
        break;
      case "Panel":
        let panel = orderItem;
        totalLinealFootOfCoilNeededForPanels = Number(
          panel &&
            panel.calculations &&
            panel.calculations.linealFeetOfCoilWithWaste
            ? Number(panel.calculations.linealFeetOfCoilWithWaste ?? 0)
            : 0
        );
        coilWidthNeededForPanels = Number(
          panel && panel.calculations && panel.calculations.masterCoilSizeNeeded
            ? Number(panel.calculations.masterCoilSizeNeeded ?? 0)
            : 0
        );
        totalPanelCoilSquareFeet = Number(
          panel &&
            panel.calculations &&
            panel.calculations.finishedPanelSquareFeet
            ? Number(panel.calculations.finishedPanelSquareFeet ?? 0)
            : 0
        );
        totalPanelCoilSquareFeetIncDrop = Number(
          panel &&
            panel.calculations &&
            panel.calculations.squareFeetOfCoilNeededWithWaste
            ? Number(panel.calculations.squareFeetOfCoilNeededWithWaste ?? 0)
            : 0
        );
        totalPanelAreaCoverage = toThreeDecimals(
          (panel &&
          panel.calculations &&
          panel.calculations.linealFeetOfCoilNoWaste &&
          panel.panelWidth
            ? Number(panel.calculations.linealFeetOfCoilNoWaste ?? 0) *
              Number(panel.panelWidth ?? 0)
            : 0) / 12
        );
        break;
      case "TrimAndFlashing":
        // TrimAndFlashing
        // - This is different from new version because new version calculates flats needed for the whole TrimAndFlashing and not each piece
        // - (OLD) flatsNeeded += parseInt(trimPiece.calculations.flatSheetsNeeded)
        // - (NEW) flatsNeeded += Number(orderItem.variables.flatsUsed) + Number(orderItem.variables.extra_flats)
        // - HOW TO CHECK OLD VS NEW: check if orderItem.variables.flatUsed or orderItem.variables.extra_flats exists, then new, if not, then old
        // Default value for variables.flats_used is NULL. So old orders will have it as NULL
        if (orderItem.variables && orderItem.variables.flats_used != null) {
          flatsNeeded +=
            Number(orderItem.variables.flats_used ?? 0) +
            Number(orderItem.variables.extra_flats ?? 0);
        } else {
          let trimPieces = orderItem.trimPieces;
          for (const trimPiece of trimPieces) {
            let flats = Number(trimPiece.calculations.flatSheetsNeeded ?? 0);
            flatsNeeded += flats;
          }
        }

        break;
      case "CopingCap":
        // CopingCap
        // - This is different from new version because new version calculates flats needed for the whole TrimAndFlashing and not each piece
        // - (OLD) flatsNeeded += parseInt(capPiece.calculations.flatSheetsNeeded)
        // - (NEW) flatsNeeded += Number(orderItem.variables.flatsUsed) + Number(orderItem.variables.extra_flats)
        // - HOW TO CHECK OLD VS NEW: check if orderItem.variables.flatUsed or orderItem.variables.extra_flats exists, then new, if not, then old
        // Default value for variables.flats_used is NULL. So old orders will have it as NULL
        if (orderItem.variables && orderItem.variables.flats_used != null) {
          flatsNeeded +=
            Number(orderItem.variables.flats_used ?? 0) +
            Number(orderItem.variables.extra_flats ?? 0);
        } else {
          let capPieces = orderItem.capPieces;
          for (const capPiece of capPieces) {
            let flats = Number(capPiece.calculations.flatSheetsNeeded ?? 0);
            flatsNeeded += flats;
          }
        }
        break;
      case "CopingCapCleat":
        // CopingCapCleat
        // - This is different from new version because new version calculates flats needed for the whole TrimAndFlashing and not each piece
        // - (OLD) galvFlatsNeeded += parseInt(cleatPiece.calculations.flatSheetsNeeded)
        // - (NEW) galvFlatsNeeded += Number(orderItem.variables.flatsUsed) + Number(orderItem.variables.extra_flats)
        // - HOW TO CHECK OLD VS NEW: check if orderItem.variables.flatUsed or orderItem.variables.extra_flats exists, then new, if not, then old
        // Default value for variables.flats_used is NULL. So old orders will have it as NULL
        if (orderItem.variables && orderItem.variables.flats_used != null) {
          galvFlatsNeeded +=
            Number(orderItem.variables.flats_used ?? 0) +
            Number(orderItem.variables.extra_flats ?? 0);
        } else {
          let cleatPieces = orderItem.cleatPieces;
          for (const cleatPiece of cleatPieces) {
            let flats = Number(cleatPiece.calculations.flatSheetsNeeded ?? 0);

            galvFlatsNeeded += flats;
          }
        }
        break;
      case "BenchWork":
        // BenchWork
        // - New version actually saves the total flats needed on the orderitem although it would be equal to adding up FS for each piece
        // - (OLD) flatsNeeded += parseInt(capPiece.calculations.flatSheetsNeeded)
        // - (NEW) flatsNeeded += Number(orderItem.variables.flatsUsed) + Number(orderItem.variables.extra_flats)
        // - HOW TO CHECK OLD VS NEW: check if orderItem.variables.flatUsed or orderItem.variables.extra_flats exists, then new, if not, then old
        // Default value for variables.flats_used is NULL. So old orders will have it as NULL
        if (orderItem.variables && orderItem.variables.flats_used != null) {
          flatsNeeded +=
            Number(orderItem.variables.flats_used ?? 0) +
            Number(orderItem.variables.extra_flats ?? 0); // Extra flats doesnt actually exist for BenchWork
        } else {
          let benchWorkPieces = orderItem.benchWorkPieces;
          for (const benchWorkPiece of benchWorkPieces) {
            flatsNeeded += Number(benchWorkPiece.flatSheets ?? 0);
          }
        }
        break;
      case "SplicePlate":
        // SplicePlate
        // - This is different from new version because new version calculates flats needed for the whole TrimAndFlashing and not each piece
        // - (OLD) flatsNeeded += parseInt(plate.calculations.flatSheetsNeeded);
        // - (NEW) flatsNeeded += Number(orderItem.variables.flatsUsed) // Splice Plates DONT have extra flats in both new and old
        // - HOW TO CHECK OLD VS NEW: check if orderItem.variables.flatUsed exists, then new, if not, then old
        // Default value for variables.flats_used is NULL. So old orders will have it as NULL
        if (orderItem.variables && orderItem.variables.flats_used != null) {
          flatsNeeded +=
            Number(orderItem.variables.flats_used ?? 0) +
            Number(orderItem.variables.extra_flats ?? 0); // Extra flats doesnt actually exist for splice plates
        } else {
          let plates = orderItem.plates;
          for (const plate of plates) {
            let flats = Number(plate.calculations.flatSheetsNeeded ?? 0);
            flatsNeeded += flats;
          }
        }
        break;
      case "Accessory":
        // Accessory (Yup we had an accessory named "flat sheet")
        // - exactly the same as before
        // - (OLD) standaloneFlats += accessoryItem.quantity
        // - (NEW) standaloneFlats += accessoryItem.quantity
        for (const accessoryItem of orderItem.items) {
          if (accessoryItem.name.toLowerCase().includes("flat sheet")) {
            standaloneFlats += Number(accessoryItem.quantity ?? 0);
          }
        }
        break;
      default:
        break;
    }
  }

  let other = getMaterialNeeded(order);
  let materials = {
    flatsNeeded,
    standaloneFlats,
    galvFlatsNeeded,
    totalLinealFootOfStandaloneCoil,
    totalLinealFootOfCoilNeededForPanels,
    coilWidthNeededForPanels,
    totalPanelCoilSquareFeet,
    totalPanelCoilSquareFeetIncDrop,
    totalPanelAreaCoverage,
    ...other,
  };
  return materials;
};

const getMaterialNeeded = (order) => {
  let gauge = `${order.gauge}${order.gauge < 1 ? "mm" : "g"}`;
  let color = order.color;
  let manufacturer = order.manufacturer;
  let flatSheetSize = Number(order.flatSheetSize ?? 0);
  let flatSheetCost = Number(order.flatSheetCost ?? 0);
  // Old version of calculations stores galv fs cost at order.galvFlatSheetCost
  // New Version stores it on the orderitem's override.flat_sheet_cost
  // So default to old version and then check the orderitem
  // If orderitem's overrides flat_sheet_cost has a value then use that
  let galvFlatSheetCost = Number(order.galvFlatSheetCost ?? 0);
  let galvFlatSheetGauge = "";
  let galvFlatSheetSize = flatSheetSize;

  if (order.isCustomMaterial) {
    gauge = order.customGauge;
    color = order.customColor;
    manufacturer = order.customManufacturer;
  }
  let coilDropLF = 0;
  let coilDropSF = 0;
  let coilDropTotalPrice = 0;
  let panelCalcs = null;
  let coilPricePerSF = Number(order.coilCostPerSqFt ?? 0);

  // Watch for Overrides?
  // - Panel override LF
  // Extra Flats
  // How about old version of the order
  for (const orderItem of order.items) {
    switch (orderItem.objectType) {
      case "Panel":
        // COIL
        panelCalcs = orderItem.calculations;
        // DROP
        let totalCoilsYielded = Math.floor(
          panelCalcs.masterCoilSizeNeeded / panelCalcs.coilSizeNeeded
        ); // panels number fit on master coil width
        let dropLF =
          parseFloat(panelCalcs.coilDrop) > 0
            ? toTwoDecimals(panelCalcs.linealFeetOfCoilWithWaste) /
              totalCoilsYielded
            : 0;
        let dropSF = toThreeDecimals(dropLF * (panelCalcs.coilDrop / 12));
        coilDropLF = dropLF;
        coilDropSF = dropSF;
        coilDropTotalPrice = toTwoDecimals(dropSF * coilPricePerSF);
        break;
      case "CopingCapCleat":
        // galvFlatSheetGauge =
        //   orderItem.gauge + " " + orderItem.gaugeUnitOfMeasure;
        galvFlatSheetGauge = parseFloat(orderItem.gauge ?? 0);
        if (orderItem.overrides && orderItem.overrides.flat_sheet_cost) {
          galvFlatSheetCost = Number(orderItem.overrides.flat_sheet_cost ?? 0);
        }

        break;

      default:
        break;
    }
  }
  let materials = {
    color,
    gauge,
    manufacturer,
    coilPricePerSF, // setPricePerSquareFeetOfCoil(materialsNeeded.coil.coilPricePerSF);

    // coil,
    coilDropLF,
    coilDropSF,
    coilDropTotalPrice,
    // From coil.calculations
    panelCoilDrop: Number(panelCalcs ? panelCalcs.coilDrop : 0),
    linealFeetOfCoilWithWaste: Number(
      panelCalcs ? panelCalcs.linealFeetOfCoilWithWaste : 0
    ), // setLinealFeetOfCoil(materialsNeeded.coil.linealFeetOfCoilWithWaste);
    squareFeetOfCoilNeededWithWaste: Number(
      panelCalcs ? panelCalcs.squareFeetOfCoilNeededWithWaste : 0
    ), // setSquareFeetOfCoil(materialsNeeded.coil.squareFeetOfCoilNeededWithWaste);
    masterCoilSizeNeeded: Number(
      panelCalcs ? panelCalcs.masterCoilSizeNeeded : 0
    ), // setMasterCoilWidthInches(materialsNeeded.coil.masterCoilSizeNeeded);
    coilSizeNeeded: Number(panelCalcs ? panelCalcs.coilSizeNeeded : 0), // setCoilWidthInches(materialsNeeded.coil.coilSizeNeeded);
    panelMaterialCost: Number(panelCalcs ? panelCalcs.materialCost : 0), // setCoilTotalPrice();
    //
    // flatsNeeded,
    flatSheetSize,
    flatSheetCost,
    //
    // galvFlatsNeeded,
    galvFlatSheetCost,
    galvFlatSheetGauge,
    galvFlatSheetSize,
  };
  return materials;
};

export default getMaterialSummaryData;
